import React from "react";
import { Link } from "react-router-dom";
import { projects } from "../mock";

export default function Projects() {
  return (
    <section id="projects" className="py-20 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl font-semibold text-gray-900 mb-12 text-center">
          Projects
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project) => (
            <Link
              key={project.id}
              to={`/project/${project.id}`}
              className="group block"
            >
              {/* Thumbnail */}
              <div className="overflow-hidden rounded-lg mb-4">
                <img
                  src={project.thumbnail}
                  alt={project.title}
                  className="w-full aspect-[16/10] object-cover group-hover:scale-[1.02] transition-transform duration-300"
                />
              </div>

              {/* Title + date */}
              <h3 className="text-base font-medium text-gray-900 mb-1">
                {project.title}
              </h3>
              <p className="text-sm text-gray-400">
                {project.dates}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
